import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Input, Label, FormGroup, Button } from "reactstrap";
import { getCategories } from "../../redux/actions/indexActions";
const AddSubSubCategory = () => {
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth },
    indexReducer: { categoriesList }
  } = useSelector((state) => state);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [formData, setFormData] = useState({
    name_english: "",
    name_hindi: "",
    category_id: "",
    sub_category_id: "",
    title_english: "",
    title_hindi: "",
    description_english: "",
    short_description_english: "",
    description_hindi: "",
    short_description_hindi: "",
    status: 1,
    landscape_image: "",
    featured: 0,
    portrait_image: "",
  });
  const [errors, setErrors] = useState();
  const navigate = useNavigate();
  const inputHandler = (e) => {
    const { name, value } = e.target;
    const file = e.target.files ? e.target.files[0] : null;
    if (name === "portrait_image" || name === "landscape_image") {
      const url = URL.createObjectURL(file);
      const image = new Image();
      image.src = url;
      console.log(url, "target");

      image.onload = () => {
        const width = image.width;
        const height = image.height;

        if (name === "portrait_image" && (width !== 1280 || height !== 1920)) {
          setErrors({ ...errors, portrait_image: "Image dimensions must be 1280x1920 pixels" });
        } else if (name === "landscape_image" && (width !== 1080 || height !== 720)) {
          setErrors({ ...errors, landscape_image: "Image dimensions must be 1080x720 pixels" });
        } else {
          setErrors({ ...errors, [name]: "" });
          setFormData({ ...formData, [name]: file });
        }
      };
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  useEffect(() => {
    dispatch(getCategories(auth.token));
    // eslint-disable-next-line
  }, [auth.token]);

  useEffect(() => {
    if (formData?.category_id) {
      axios(`/api/admin/v1/get-subcategory-by-category/${formData?.category_id}`)
        .then(({ data }) => {
          console.log(data, 'ldad');
          setSubCategoryList(data?.subCategoriesbyCategory);
        })
        .catch((err) => console.error(err));
    } else {
      setSubCategoryList([]);
    }
  }, [formData?.category_id]);

  const handleSubmit = () => {
    const form = new FormData();
    form.append('category_id', formData.category_id)
    form.append('sub_category_id', formData.sub_category_id)
    form.append('title_english', formData.title_english)
    form.append('title_hindi', formData.title_hindi)
    form.append('name_english', formData.name_english)
    form.append('name_hindi', formData.name_hindi)
    form.append('short_description_english', formData.short_description_english)
    form.append('short_description_hindi', formData.short_description_hindi)
    form.append('description_english', formData.description_english)
    form.append('description_hindi', formData.description_hindi)
    form.append('landscape_image', formData.landscape_image)
    form.append('portrait_image', formData.portrait_image)
    form.append("featured", formData.featured)
    form.append("status", formData.status)
    axios
      .post(`/api/admin/v1/sub-sub-category`, form, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        setErrors(err.response.data);
        toast.error(err.response.data);
      });
  };

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h5 className="text-white">Add Sub Sub Category</h5>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Category<span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.category_id}
                type="select"
                name="category_id"
                onChange={inputHandler}
              >
                <option value="">Select Category</option>
                {categoriesList.map((item) => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item?.name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.category_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Sub Category<span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.sub_category_id}
                type="select"
                name="sub_category_id"
                onChange={inputHandler}
              >
                <option value="">Select Sub Category</option>
                {subCategoryList.map((item) => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item?.name_english}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.sub_category_id}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Title English <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.title_english)}
                value={formData?.title_english}
                name="title_english"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.title_english}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Title Hindi</Label>
              <Input
                invalid={Boolean(errors?.title_hindi)}
                value={formData?.title_hindi}
                name="title_hindi"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.title_hindi}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>English Name <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.name_english)}
                value={formData?.name_english}
                name="name_english"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.name_english}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Hindi Name</Label>
              <Input
                invalid={Boolean(errors?.name_hindi)}
                value={formData?.name_hindi}
                name="name_hindi"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.name_hindi}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Landscape Image (1080*720)</Label>
              <Input
                type="file"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    landscape_image: e.target.files[0],
                  }))
                }
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Portrait Image (1280*1920)</Label>
              <Input
                type="file"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    portrait_image: e.target.files[0],
                  }))
                }
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Short Hindi Description</Label>
              <Input
                invalid={Boolean(errors?.short_description_hindi)}
                name="short_description_hindi"
                value={formData?.short_description_hindi}
                type="textarea"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.short_description_hindi}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Short English Description <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.short_description_english)}
                name="short_description_english"
                value={formData?.short_description_english}
                type="textarea"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.short_description_english}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>English Full Description</Label>
              <Input
                value={formData?.description_english}
                name="description_english"
                type="textarea"
                onChange={inputHandler}
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Hindi Full Description</Label>
              <Input
                value={formData?.description_hindi}
                name="description_hindi"
                type="textarea"
                onChange={inputHandler}
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Featured</Label>
              <Input
                value={formData?.featured}
                name="featured"
                onChange={inputHandler}
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSubSubCategory;
